import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { FF2, TextInput, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const TypeOther = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()
  const type = useWatch({ control, name: `suspiciousActivityInfo.cyberEventIndicators.${index as 0}.type` })
  const other = type === 'Other'

  return (
    <Controller
      name={`suspiciousActivityInfo.cyberEventIndicators.${index as 0}.typeOther`}
      control={control}
      rules={{ validate: (value) => (other ? Validators.required.field(value) : undefined) }}
      render={({ field }) => (
        <FF2
          required={other}
          label="Event Type Other"
          field={field}
          input={(props) => <TextInput {...props} disabled={!other} />}
        />
      )}
    />
  )
}
